import { render, staticRenderFns } from "./TabelaPercentual.vue?vue&type=template&id=50e61223"
import script from "./TabelaPercentual.vue?vue&type=script&lang=js"
export * from "./TabelaPercentual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports